import { createFileRoute } from '@tanstack/react-router';

import { EquipePrecifieldPage } from '@support';

export const Route = createFileRoute('/_app/equipe-precifield')({
  component: EquipePrecifieldPage,
});
